/**
 * WhatsApp delivery settings (ADR 0019): the organization's WhatsApp gateway, the same API Deem uses
 * (base URL + instance + token, UltraMsg-compatible). Sign-in codes and password-reset codes go through it.
 */
import { z } from "zod";
import { phone } from "./fields.js";
export const WhatsAppSettingsQuery = z.object({ organizationId: z.uuid() });
export const WhatsAppSettingsResponse = z.object({
    baseUrl: z.string().nullable(),
    instanceId: z.string().nullable(),
    /** The token is never sent back; only whether one is stored. */
    hasToken: z.boolean(),
    active: z.boolean(),
    lastTestedAt: z.string().nullable(),
    lastTestedOk: z.boolean().nullable(),
});
export const UpdateWhatsAppSettingsBody = z.object({
    organizationId: z.uuid(),
    baseUrl: z.url({ protocol: /^https?$/ }).max(300),
    instanceId: z.string().trim().min(1).max(120),
    /** Omitted: keep the stored token. */
    token: z.string().trim().min(1).max(500).optional(),
    active: z.boolean(),
});
export const TestWhatsAppBody = z.object({ organizationId: z.uuid(), phone });
export const TestWhatsAppResponse = z.object({ ok: z.boolean(), error: z.string().nullable() });
/**
 * Linking the WhatsApp number from the portal by QR, like Deem's settings. Works with gateways that offer the
 * instance routes of the association's own gateway (/instance/status, /qr, /connect, /relink, /logout).
 */
export const WhatsAppLinkState = z.enum([
    "connected",
    "qr_ready",
    "initializing",
    "reconnecting",
    "disconnected",
    "not_initialized",
    "unavailable",
]);
export const WhatsAppConnectionResponse = z.object({
    state: WhatsAppLinkState,
    /** The linked number (digits) once connected. */
    phone: z.string().nullable(),
    /** A data: URL image to scan with WhatsApp while the state is qr_ready. */
    qrCode: z.string().nullable(),
    /** The gateway's own text when it could not be reached or refused. */
    error: z.string().nullable(),
});
export const WhatsAppConnectionAction = z.enum(["connect", "relink", "logout"]);
export const WhatsAppConnectionBody = z.object({
    organizationId: z.uuid(),
    action: WhatsAppConnectionAction,
});
//# sourceMappingURL=whatsapp.js.map